import React from 'react';
import { Flex } from '@goodrx/matisse-react';
import { ComponentRenderer } from '@goodrx/x-core';
import { BlockConfig } from '../../../BlockConfig';
export const ColumnBlock = ({
  className,
  componentMap,
  contentCollection,
  mobileConfig,
  tabletConfig
}) => {
  const items = (contentCollection === null || contentCollection === void 0 ? void 0 : contentCollection.items.filter(item => !!item)) || [];
  const mobileConfigWithDefault = { ...(mobileConfig || {}),
    marginBottom: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom) || '0',
    align: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align) || 'left'
  };
  const tabletConfigWithDefault = { ...(tabletConfig || {}),
    marginBottom: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom) || '0',
    align: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align) || 'left'
  };
  return /*#__PURE__*/React.createElement(BlockConfig, {
    className: className,
    mobileConfig: mobileConfigWithDefault,
    tabletConfig: tabletConfigWithDefault
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    width: "100%"
  }, items.map(data => /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: data,
    key: data.sys.id,
    componentMap: componentMap
  }))));
};